module.exports = __webpack_public_path__ + "static/media/pickup.cd3522da.svg";